<template>
  <div
    class="message-bubble"
    :class="me"
    @click="abrirImagenGrande"
  >
    <span
      class="from"
      :class="me"
    >{{ nombre }}</span>
    <br>
    <span v-if="!mostrarImagen"
      class="message-text"
    >{{ texto }}</span>
    <img v-bind:src="base64" v-if="mostrarImagen" width="150px" />
    <template v-if="me == 'me'">
      <span class="date" v-if="history && history.MENSAJES_LEIDOS == 1">Leído</span>
      <span class="date" v-else>No leído</span>
    </template>
    <span class="date">{{getFecha}}</span>
    <v-dialog
        v-model="imagenGrande" id="imagenGrande"
        max-width="900px"
      >
        <img v-bind:src="base64Grande" width="100%" />
    </v-dialog>

  </div>
</template>

<script>

import {mapActions} from 'vuex'
import moment from 'moment'

export default {
  name: 'message-bubble',
  props: ['uuid', 'text', 'nombre', 'imagen', 'timetoken', 'adjunto_miniatura', 'contenido_adjunto', 'history'],
  data () {
    return {
      texto: '',
      mostrarImagen: false,
      base64: null,
      base64Grande: null,
      imagenGrande: false
    }
  },
  computed: {
    me () {
      let result = false

      const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}
      const userUUID = usuarioJson.id

      if (userUUID === this.uuid) {
        result = true
      }

      // Render the message bubble on the right side if it is from this client
      return result ? 'me' : ''
    },
    getFecha () {
      return this.timetoken ? moment.unix(new Date(this.timetoken).getTime() / 1000).format("DD/MM/YYYY HH:mm") : null
    }
  },
  beforeMount () {
    if (this.imagen === true) {
      console.log(this)
      this.base64 = require('@/assets/cargando.gif')
      this.base64Grande = require('@/assets/cargando.gif')
      this.mostrarImagen = true
      if(this.adjunto_miniatura !== undefined) {
        if (this.adjunto_miniatura.indexOf('data:') >= 0) {
          this.base64 = this.adjunto_miniatura
          this.base64Grande = this.contenido_adjunto
        } else {
          this.base64 = 'data:image/png;base64,' + this.adjunto_miniatura
          this.base64Grande = 'data:image/png;base64,' + this.contenido_adjunto
        }
      } else {
        this.obtenerImagenChat(this.text)
        .then(e => {
          var respuesta = e.data.result.data
          console.log('respuesta imagen', respuesta)
          this.base64 = 'data:image/png;base64,' + respuesta.data[0].ADJUNTO_MINIATURA
          this.base64Grande = 'data:image/png;base64,' + respuesta.data[0].CONTENIDO_ADJUNTO
        })
        .catch(e => {
          console.log(e)
        })
      }
    } else if (this.text.indexOf('data:') >= 0) {
      this.base64 = this.text
      this.mostrarImagen = true
    } else {
      this.texto = this.text
      this.mostrarImagen = false
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      obtenerImagenChat: 'chat/obtenerImagenChat'
    }),
    isBase64 (str) {
      if (str === '' || str.trim() === '') { return false }
      try {
        return btoa(atob(str)) === str
      } catch (err) {
        return false
      }
    },
    abrirImagenGrande() {
      if (this.base64Grande !== null) {
        this.imagenGrande = true
      } else {
        console.log('no hay base64')
      }
    }
  }
}
</script>

<style scoped>
.message-bubble {
  display: block;
  max-width: 50%;
  margin-bottom: 4px;
  float: left;
  clear: both;
}

.message-text {
  padding: 8px;
  margin: 4px;
  text-align: left;
  background-color: #dfdfdf;
  border-radius: 4px;
  max-width: 400px;
  word-break: break-word;
}

.message-bubble.me {
  float: right;
  word-break: break-word;
}

.message-bubble.me .message-text {
  background-color: #9ec6f5;
}

.from {
  float: left;
  margin: 4px;
  font-size: 10px;
  color: #9DA7AF;
}

.from.me {
  display: block;
}

.message-bubble span {
  display: block;
}

.message-bubble.me br.me {
  display: none;
}

.date {
  float: right;
  margin: 4px;
  font-size: 10px;
  color: #9DA7AF;
}
</style>
